import { useEffect, useRef, useState, type ReactElement } from "react";
import { useServices } from "./Services";

/** Renders the Turnstile widget and reports its token once. */
export function TurnstileBox({ onToken }: { onToken: (token: string) => void }): ReactElement {
  const { turnstile } = useServices();
  const ref = useRef<HTMLDivElement>(null);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const cb = useRef(onToken);
  cb.current = onToken;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctrl = new AbortController();
    setFailed(false);
    turnstile.getToken(el, ctrl.signal).then(
      (token) => {
        if (!ctrl.signal.aborted) cb.current(token);
      },
      () => {
        if (!ctrl.signal.aborted) setFailed(true);
      },
    );
    return () => {
      ctrl.abort();
      el.replaceChildren();
    };
  }, [turnstile, attempt]);

  return (
    <div className="z-turnstile">
      <p className="z-mono z-small">İnsan mısın, ajan mı? Kısa bir doğrulama.</p>
      <div ref={ref} className="z-turnstile__slot" />
      {failed && (
        <p role="alert" className="z-small">
          Doğrulama yüklenemedi.{" "}
          <button
            type="button"
            className="z-linkbtn"
            onClick={() => {
              setAttempt((n) => n + 1);
            }}
          >
            Tekrar dene
          </button>
        </p>
      )}
    </div>
  );
}
